export default "__VITE_ASSET__53501a86__"